export default {
  methods: {
    redirect (response) {
      window.location.reload()
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/auth/redirect.js